<template>
  <select class="form-control" @change="countryChange" v-model="def" id="idd-selector">
    <option 
      :title="item.name"
      v-for="item in this.items"
      :key="item.id"
      :value="item.id"
      :selected="def == item.id"
    >
      {{ item.emoji }} (+{{ item.phonecode }})
    </option>
  </select>
</template>

<script>
import apiMixins from "@/mixins/apiMixins";
export default {
  data() {
    return {
      items: [],
      def: this.cId,
    };
  },
  props: {
    cId: {
      type: Number,
      default: 30,
    },
  },
  mixins: [apiMixins],
  created() {
    this.getCountry();
  },
  methods: {
    async getCountry() {
      const responseApi = await this.requestApiData("/country", "get");
      this.items = responseApi.data;
    },
    countryChange() {
      this.$emit("getCountry", this.def);
    },
  },
};
</script>

<style scoped>
.form-control {
  padding-left: 0;
  padding-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Country.vue